<template>
  <div id="app">
    <Layout :class="bgClass" v-if="isRouterAlive">
      <Header ref="headers"></Header>
      <Content :style='{width:"1200px",margin:"0 auto",minHeight:Height+"px"}'>
          <router-view></router-view>
      </Content>
      <Footer></Footer>
    </Layout>
    <BackTop></BackTop>
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import BackTop from '@/components/backTop/Index.vue'
export default {
  name: 'App',
  // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      Height: 0,
      isRouterAlive: true,
      isHeaderAlive: true,
      bgClass: '',
      handleKey: 1
    }
  },
  components: {
    Header,
    Footer,
    BackTop
  },
  updated () {
    const path = this.$route.path
    if (path.indexOf('login') > -1) {
      this.bgClass = 'bg-img'
    } else {
      this.bgClass = ''
    }
    // this.handleKey = Math.random()*100
  },
  mounted () {
  // 动态设置内容高度 让footer始终居底   header+footer的高度是238
    this.Height = document.documentElement.clientHeight - 238
    window.onresize = () => { this.Height = document.documentElement.clientHeight - 238 }
    window.addEventListener('storage', this.reportParamsObjStorage, false)
  },
  destroyed () {
    window.removeEventListener('storage', this.reportParamsObjStorage)
  },
  methods: {
    reload () {
      this.isRouterAlive = false // 先关闭,
      this.$nextTick(() => {
        this.isRouterAlive = true // 再打开
      })
    },
    reportParamsObjStorage (e) {
      if (e.key.indexOf('token') > -1) {
        this.reload()
        this.$router.push('/')
        this.$refs.headers.handleLoginStatus()
      }
    }
  }
}
</script>

<style>
html,
body {
  padding: 0px;
  margin: 0px;
  height: 100%;
}
#app {
  height: 100%;
  /* background-color: #f5f7f9; */
}
.bg-img{
  background-image: url("./assets/xs-bg.png") !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  background-size: 1920px !important;
  background-color: #fff;
}
.border-img{
  position: absolute;
}
.border-top-left {
  top: 20px;
  left: 20px;
}

.border-top-right{
  top: 20px;
  right: 20px;
}
.border-bottom-left{
  bottom: 20px;
  left: 20px;
}
.border-bottom-right{
  bottom: 20px;
  right: 20px;
}
.banner-home{
  width: 100%;
  background: #000;
  position: absolute!important;
  top: 82px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 1200px;
  height: 420px;
  overflow: hidden;
}
.banner{
  height: 200px;
  width: 100%;
  background: #000;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute!important;
  top: 82px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 1200px;
}
.banner::after{
  content: '';
  position: absolute;
  left: 0px;
  top: 0;
  width: 200px;
  height: 200px;
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}
.banner::before{
  content: '';
  position: absolute;
  right: -0px;
  top: 0;
  width: 200px;
  height: 200px;
  background-image: linear-gradient(-90deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}

.flex-r{
  display: flex;
  flex-direction: row;
}

.flex-c{
  display: flex;
  flex-direction: column;
}
</style>
